import script from "./CpaSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CpaSelect.vue?vue&type=script&setup=true&lang=js"

import "./CpaSelect.vue?vue&type=style&index=0&id=0fde7b62&lang=less"

const __exports__ = script;

export default __exports__